var map = {
	"./ar.json": 6872,
	"./de.json": 5454,
	"./en.json": 9930,
	"./es.json": 7544,
	"./fr.json": 6951,
	"./hi.json": 4235,
	"./id.json": 5784,
	"./it.json": 9012,
	"./ja.json": 2729,
	"./ko.json": 954,
	"./ms.json": 8638,
	"./pt.json": 699,
	"./ru.json": 3272,
	"./th.json": 7565,
	"./tr.json": 2568,
	"./zh.json": 3973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1339;